import styled from "styled-components";

const SIZE = "1rem";
const INSET = "0.5px";
const BORDER_WIDTH = "1.5px";
const TRANSITION_DURATION = "0.07s";

export const CheckboxWrapper = styled.div`
  position: relative;
  width: ${SIZE};
  height: ${SIZE};
  flex-shrink: 0;

  & > svg {
    position: absolute;
    width: calc(${SIZE} - (${INSET} * 2));
    height: calc(${SIZE} - (${INSET} * 2));
    inset: ${INSET};
    pointer-events: none;
    opacity: 0;
    transition: opacity ${TRANSITION_DURATION} ease;
    stroke: ${(p) => p.theme.color.palette.snowWhite};
  }

  & > input:checked ~ svg {
    opacity: 1;
  }

  & > input:disabled ~ svg {
    stroke: ${(p) => p.theme.color.palette.nickelGrey};
  }
`;

export const Checkbox = styled.input`
  display: flex;
  appearance: none;
  background-color: transparent;
  margin: 0;

  border: ${BORDER_WIDTH} solid ${(p) => p.theme.text.default};
  width: ${SIZE};
  height: ${SIZE};
  border-radius: 3px;
  cursor: pointer;

  transition:
    box-shadow ${TRANSITION_DURATION} ease,
    border-width ${TRANSITION_DURATION} ease,
    background-color ${TRANSITION_DURATION} ease,
    border-color ${TRANSITION_DURATION} ease,
    outline-width 0s;
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  position: relative;
  user-select: none;

  & > span {
    font-size: inherit;
    color: inherit;
    cursor: pointer;
  }

  &:has(input:disabled) {
    cursor: not-allowed;
    color: ${(p) => p.theme.text.disabled};
  }

  & input[type="checkbox"]:disabled ~ span {
    color: ${(p) => p.theme.text.disabled};
    cursor: not-allowed;
  }

  & input[type="checkbox"]:checked {
    background-color: ${(p) => p.theme.color.brand.blue};
    border-color: ${(p) => p.theme.color.brand.blue};
  }

  /*
    This combined selector is needed to avoid a FOUC when clicking on the
    label, because the checkbox is briefly unfocused in between the mousedown
    and mouseup events.
  */
  & input[type="checkbox"]:active,
  &:active input[type="checkbox"] {
    background-color: ${(p) => p.theme.color.brand.blue};
    border: calc(${BORDER_WIDTH} - 1px) solid ${(p) => p.theme.text.default};

    /*
      Use box-shadow to emulate outline to avoid a Firefox bug where built-in
      focus animations of outline override ours. This is the same trick that our
      slider control already uses. Safari sadly uses box-shadow (and is even
      less overridable than Firefox's use of outline for the focus animation), but
      our customer base is 95%+ Windows users so we'll let Safari have bouncy
      checkboxes.
    */
    outline: none;
    box-shadow: 0 0 0 1.5px ${(p) => p.theme.text.default};
  }

  & input[type="checkbox"]:focus,
  &:focus-within input[type="checkbox"],
  &:focus-visible input[type="checkbox"] {
    border: calc(${BORDER_WIDTH} - 1px) solid ${(p) => p.theme.text.default};
    outline: none;
    box-shadow: 0 0 0 1.5px ${(p) => p.theme.text.default};
  }

  & input[type="checkbox"]:disabled {
    border: ${BORDER_WIDTH} solid ${(p) => p.theme.text.disabled};
    cursor: not-allowed;
  }

  & input[type="checkbox"]:disabled:checked {
    background-color: ${(p) => p.theme.text.disabled};
    border-color: ${(p) => p.theme.text.disabled};
  }
`;
